// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sc-message-list[data-v-20cd1cb2]{height:80%;overflow-y:auto;background-size:100%;padding:40px 20px}", ""]);
// Exports
module.exports = exports;
